module.exports = __webpack_public_path__ + "img/total_processing.424112c0.png";